'use client';
import React, { useEffect, useState } from 'react';
import { FaHome, FaEnvelope } from 'react-icons/fa';
import {
    Twitter,
    LinkedInLogo,
    DOI,
    P,
} from '@/assets/EidrHeaderAssets';
import config from '@/config';
import SlalomLogo from '@/assets/slalom.svg';
import GstreetLogo from "@/assets/gstreet-logo.svg"
import SessionState from "@/lib/session-state"
import { observer } from "mobx-react-lite";
import Spinner from "@/components/Spinner"
import ParLogo from "@/assets/pariveda-logo.svg";


function EidrFooter() {

    //const [isLoggedIn, setIsLoggedIn] = useState(null);
    //let isLoggedIn = null;

    const handleEmailClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault(); // Prevent the default link behavior
        const subject = 'Web UI Support Question';
        const encodedSubject = encodeURIComponent(subject);
        const mailtoLink = `mailto:support@eidr.org?subject=${encodedSubject}`;
        window.location.href = mailtoLink;
    };


    const RegistryStatus =
        observer(
            // @ts-ignore
            ({ sessionState }) => {
                if (sessionState.isLoggedIn === undefined) {
                    return (<Spinner></Spinner>)
                }

                switch (config.APP_STAGE) {
                    case "dev":
                        if (sessionState.isLoggedIn === true) {
                            // isLoggedIn = true
                            if (sessionState.isEidrUser) {
                                return (<>sandbox2.eidr.org </>)
                            } else {
                                return (<>sandbox2-mirror.eidr.org </>)
                            }
                        } else if (sessionState.isLoggedIn === false) {
                            // isLoggedIn = false
                            return (<>sandbox2-mirror.eidr.org </>)
                        }
                    case "staging":
                        if (sessionState.isLoggedIn === true) {
                            // isLoggedIn = true
                            if (sessionState.isEidrUser) {
                                return (<>sandbox1.eidr.org </>)
                            } else {
                                return (<>sandbox1.eidr.org </>)
                            }
                        } else if (sessionState.isLoggedIn === false) {
                            // isLoggedIn = false
                            return (<>sandbox1.eidr.org </>)
                        }
                    default:
                        if (sessionState.isLoggedIn === true) {
                            // isLoggedIn = true
                            if (sessionState.isEidrUser) {
                                return (<>registry1.eidr.org </>)
                            } else {
                                return (<>resolve.eidr.org </>)
                            }
                        } else if (sessionState.isLoggedIn === false) {
                            // isLoggedIn = false
                            return (<>resolve.eidr.org </>)
                        }
                }

            });


    return (
        <footer className="w-full bg-theme-blue text-white py-4 md:py-2">
            <div className="container">
                <div className="flex flex-col xl:flex-row items-center justify-between">
                    <div className="flex flex-row items-center justify-between space-x-3 md:space-x-4 ">
                        <a href="#email" onClick={handleEmailClick} className="flex items-center">
                            <FaEnvelope size="1.4rem" />
                        </a>
                        <a href={config.EIDR_TWITTER_URL} target="_blank" rel="noreferrer"
                            className="flex items-center">
                            <Twitter />
                        </a>
                        <a href={config.EIDR_LINKEDIN_URL} target="_blank" rel="noreferrer"
                            className="flex items-center">
                            <LinkedInLogo />
                        </a>
                        <a href="https://www.eidr.org/" target="_blank" rel="noreferrer" className="flex items-center">
                            <FaHome size="2.0rem" />
                        </a>
                        <a href="https://www.doi.org/" target="_blank" rel="noreferrer"
                            className="flex items-center ml-1">
                            <DOI />
                        </a>
                    </div>
                    <div className="flex flex-row items-center justify-between">
                        <a href="https://www.eidr.org/privacy-policy/" target="_blank" rel="noreferrer" className="underline">Privacy Policy</a>
                    </div>
                    <div className="flex flex-row items-center justify-between ">
                        <span className="text-sm m-1">Powered by</span>
                        <a href="https://www.slalom.com/" target="_blank" rel="noreferrer"
                            className="flex items-center ml-1">
                            <img src={SlalomLogo.src} alt="Slalom Consulting Logo" className="mr-1"
                                style={{
                                    width: 'auto',
                                    height: '12px',
                                    marginRight: '0.25rem',
                                }}
                            />
                        </a>
                        <a href="https://parivedasolutions.com/" target="_blank" rel="noreferrer"
                            className="flex items-center ml-1">
                            <img
                                src={ParLogo.src}
                                alt="Par logo"
                                style={{
                                    width: 'auto',
                                    height: '10px',
                                    marginRight: '0.25rem',
                                }}
                            />
                        </a>
                        <a href="https://gstreet.net/" target="_blank" rel="noreferrer"
                            className="flex items-center ml-1">
                            <img src={GstreetLogo.src} alt="GStreet Logo" className="mr-1"
                                style={{
                                    width: 'auto',
                                    height: '14px',
                                    marginRight: '0.25rem',
                                }}
                            />
                        </a>
                    </div>
                    <div className="flex items-center justify-center">
                        <p className="text-sm text-center">
                            ©
                            <span className="hidden md:inline">{new Date().getFullYear()}</span>
                            {' '}
                            Entertainment ID Registry Association (EIDR).
                        </p>
                    </div>
                    <div className="flex items-center md:text-right">
                        <p className="text-sm">
                            <RegistryStatus sessionState={SessionState}></RegistryStatus>
                            v2.7.1
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default EidrFooter;
